import { jsx as _jsx } from "react/jsx-runtime";
import { TreeSelect } from 'antd';
import { TagRenderComponent } from './tagRender';
const { SHOW_PARENT } = TreeSelect;
const TreeMultiSelect = ({ data }) => {
    var _a, _b;
    const filterTreeNode = (input, option) => {
        return option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };
    const onChange = (checkedKeysValue) => {
        var _a, _b;
        const treeData = ((_a = data === null || data === void 0 ? void 0 : data.treeSelect) === null || _a === void 0 ? void 0 : _a.data) || [];
        const checkedKeys = new Set(checkedKeysValue);
        if (treeData) {
            checkedKeysValue === null || checkedKeysValue === void 0 ? void 0 : checkedKeysValue.forEach((key) => {
                var _a;
                const node = treeData.find((item) => item.key === key);
                if (node && node.children) {
                    (_a = node.children) === null || _a === void 0 ? void 0 : _a.forEach((childNode) => {
                        checkedKeys.delete(childNode === null || childNode === void 0 ? void 0 : childNode.value);
                    });
                }
            });
        }
        (_b = data === null || data === void 0 ? void 0 : data.treeSelect) === null || _b === void 0 ? void 0 : _b.setParentChildValue(Array.from(checkedKeys));
    };
    return (_jsx(TreeSelect, { showSearch: true, style: { width: '100%' }, value: (_a = data === null || data === void 0 ? void 0 : data.treeSelect) === null || _a === void 0 ? void 0 : _a.value, 
        // dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
        onChange: onChange, placeholder: "Please select", allowClear: true, multiple: true, popupMatchSelectWidth: false, treeData: data.treeSelect ? data.treeSelect.data : {}, treeCheckable: true, showCheckedStrategy: SHOW_PARENT, filterTreeNode: filterTreeNode, tagRender: (props) => _jsx(TagRenderComponent, { props: props, color: 'cyan' }) }, `${(_b = data === null || data === void 0 ? void 0 : data.treeSelect) === null || _b === void 0 ? void 0 : _b.title}_tree_select`));
};
export default TreeMultiSelect;
